<div class="app-loader">
  <div class="loader-container">
    <!-- Aurora background animation -->
    <div class="aurora-bg">
      <div class="aurora-layer-1"></div>
      <div class="aurora-layer-2"></div>
      <div class="aurora-layer-3"></div>
    </div>
    
    <!-- Loading content -->
    <div class="loader-content">
      <div class="logo-container">
        <img 
          src="/img/logo_long.png" 
          alt="AgriXe Logo" 
          class="logo-image"
          loading="eager">
        <div class="logo-subtitle">Auctions Platform</div>
      </div>
      
      <!-- Spinner -->
      <div class="spinner-container">
        <div class="spinner"></div>
        <div class="loading-text">Initializing...</div>
      </div>
    </div>
  </div>
</div>
